import type {
  Leg,
  LegState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/legs';

export const get = (state: LegState, id: string): Leg | undefined => state.byId[id];
export const all = (state: LegState): Record<string, Leg> => state.byId;
